import React from 'react';
import {
  REG_EXTERNAL_CONNECTION_TYPE_ENUM,
  REG_FORM_CONTROL_TYPE_ENUM
} from '../../../config/constants';

const EXTERNAL_CONNECTION_FORM_SECTION_CONFIG = {
  [REG_EXTERNAL_CONNECTION_TYPE_ENUM.HOCKEY_CANADA]: {
    title: 'Hockey Canada ID',
    dataField: 'hockeyCanadaId',
    verifiedDataField: 'hockeyCanadaIdVerified',
    reportable: true,
    controls: [
      {
        key: 'connection_message',
        type: REG_FORM_CONTROL_TYPE_ENUM.TEXT,
        label: 'Hockey Canada ID',
        getLabel: (regAssociation) => (
          <>
            Please enter your{' '}
            <b>Hockey Canada ID (also commonly referred to as your HCiD)</b>{' '}
            into the box below. If you do not know your HCiD the easiest place
            to find it is on any old Hockey Canada Invoice you may have. If you
            can not find your HCiD or you do not currently have one - please
            check the box below to complete your registration
          </>
        )
      },
      {
        key: 'connection_id',
        type: REG_FORM_CONTROL_TYPE_ENUM.TEXT_INPUT,
        label: 'Hockey Canada ID',
        field: 'value',
        defaultValue: '',
        isVisible: (formState) => !formState.skipConnection
      },
      {
        key: 'connection_skip',
        type: REG_FORM_CONTROL_TYPE_ENUM.CHECKBOX,
        field: 'skipConnection',
        defaultValue: false,
        getLabel: (regAssociation) => (
          <>I do not have or do not know my Hockey Canada ID</>
        )
      }
    ]
  }
};

export default EXTERNAL_CONNECTION_FORM_SECTION_CONFIG;
